import React from 'react'
import { useState } from 'react'
import { HashLink as Link } from 'react-router-hash-link';
import Lottie from "react-lottie-player"
import { useTranslation } from 'react-i18next'
import { useForm, ValidationError } from '@formspree/react'
import Modal from '../../partials/Modal'
//import slika from '../../img/slika.svg'
import slika2 from '../../img/slika2.svg'
import plant from '../../img/plant.json'
import check from '../../img/check.svg'

function HeroSection() {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openModal = () => {
    setIsModalOpen(true)
  }
  
  const closeModal = () => {
    setIsModalOpen(false);
  }

  return (
    <section className='container-fluid bg-dark'>
        <div className="container heroContainer text-white">
            <div className='imgHolder'>
              <img className='image-fluid heroImage' src={slika2} alt="" />
              <Lottie
                loop
                animationData={plant}
                play
                speed={0.5}
                className="plant"
              />
            </div>
            <div className='heroTxt d-flex flex-column justify-content-center px-20'>
              <h1 className='mb-0 heroTitle'>{t('heroTitle')}</h1>
              <p>{t('heroParagraph')}</p>
              <div className='d-flex gap10'>
                <button className='btn align-self-start my-10' onClick={openModal}>{t('heroBtn')}</button>
                <button className='btn btn-link align-self-start my-10 bg-white'><Link to="#projects" >{t('heroBtn2')}</Link></button>
              </div>
              <Modal 
                isOpen={isModalOpen} 
                closeModal={closeModal} 
                title = {t('contactFormTitle')}
                content = {<Form />}
              />
            </div>
        </div>
    </section>
  );
}

export default HeroSection;

export function Form() {
  const { t } = useTranslation();
  const [state, handleSubmit] = useForm("mjkwqlyr");

  if (state.succeeded) {
    return(
      <div className='d-flex align-items-center'>
        <i className='successIcon'><img src={check} alt="Success Icon" /></i>{t('successMsg')}
      </div>
    );
  }

  return(
    <form onSubmit={handleSubmit} id='contactForm' className='d-flex justify-content-center flex-column'>
      <div className='form-fields'>
        <label htmlFor="name" className='form-label d-block'>{t('yourName')}</label>
        <input type='text' id="name" name="name" />
      </div>
      <div className='form-fields'>
        <label htmlFor="email" className='form-label d-block'>{t('emailAddress')}</label>
        <input type='email' id="email" name="email" placeholder='example@domain.com' required />
        <ValidationError prefix="Email" field="email" errors={state.errors} />
      </div>
      <div className='form-fields'>
        <label htmlFor="message" className='form-label d-block'>{t('message')}</label>
        <textarea id="message" name="message" placeholder='Type message...' rows="6" required></textarea>
        <ValidationError prefix="Message" field="message" errors={state.errors} />
      </div>
      <button className='btn' type="submit" disabled={state.submitting}>{t('submit')}</button>
    </form>
  );
}